import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ComponentLoader, ModalContext } from 'cat-ecommerce-alloy';
import { useFitmentCheck } from '@app/hooks';
import { STATUS } from '@app/constants/commonConstants';
import ProductListItemsCount from '@app/components/common/ProductListItemsCount';
import ProductListSortBy from '@app/components/common/ProductListSortBy';
import ProductListComparisonGrid from '../ProductListComparisonGrid';
import ProductListKey from '@app/components/common/ProductListKey';
import LongDescription from '@app/components/common/LongDescription';
import styles from '../styles.module.scss';
import { useContext } from 'react';
import { isEmpty } from '@app/utils';
import ProductListFilterBoxes from '@app/components/common/ProductListFilterBoxes';
import {
  setPLPProductCardExpanded,
  setPLPQueryParam
} from '@app/store/plp/actions';
import usePagination from '../usePagination';

const ProductListMainContent = ({
  handleEquipmentCheck,
  pageDoesntExist,
  espotData
}) => {
  const uniqueIndex = useSelector(
    s => s.myEquipment.equipments.selectedEquipment?.uniqueIndex
  );
  const plpDetailsStatus = useSelector(s => s.plpUI.getPlpDetailsStatus);
  const currentCategory = useSelector(state => state.plpUI.current);
  const sortBy = useSelector(state => state.plpUI.sortBy);

  const catalogEntries = useSelector(
    state => state.categories.byId[currentCategory]?.productsId
  );
  const recordSetTotal = useSelector(
    state => state.categories.byId[currentCategory]?.productCount
  );
  const currentId = useSelector(s => s.plpUI.current);
  const longDescriptionContent = useSelector(
    s => s.categories.byId[currentId]?.categoryDescriptions
  );
  const hasCatalogEntries = !isEmpty(catalogEntries);
  const { getFitmentResult, getFitmentCheck } = useFitmentCheck();
  const selectedEquipment = !!uniqueIndex;
  const activeFacets = useSelector(state => state.plpUI.activeFacets);
  const { setUrlToPageOneWithFilter } = usePagination();

  const { modals } = useContext(ModalContext);
  const noModalsOpened = !modals.length;

  const shouldShowProductListLoader =
    noModalsOpened &&
    !(plpDetailsStatus === STATUS.RESOLVED && !pageDoesntExist) &&
    plpDetailsStatus !== STATUS.REJECTED;

  return (
    <div
      className="col-12 col-md-9 px-0 ps-md-3 mt-sm-4"
      data-testid="productGridContainer"
    >
      {hasCatalogEntries && (
        <div className="px-0 d-none d-md-flex justify-content-between mb-3">
          <div className="d-none d-md-block mt-2">
            <ProductListItemsCount
              currentItemsCount={catalogEntries?.length}
              totalItemsCount={recordSetTotal}
            />
          </div>
          <div className="d-none d-md-flex">
            <ProductListSortBy
              sortByAction={setPLPQueryParam}
              orderBy={sortBy}
              setExpanded={setPLPProductCardExpanded}
              setUrlToPageOneWithFilter={setUrlToPageOneWithFilter}
            />
          </div>
        </div>
      )}
      <div className="d-none d-md-block">
        <ProductListFilterBoxes
          activeFacets={activeFacets}
          queryActionParam={setPLPQueryParam}
          setUrlToPageOneWithFilter={setUrlToPageOneWithFilter}
        />
      </div>
      <div className="position-relative">
        <ProductListComparisonGrid
          selectedEquipment={selectedEquipment}
          getFitmentCheck={getFitmentCheck}
          getFitmentResult={getFitmentResult}
          onCheck={handleEquipmentCheck}
          espotData={espotData}
        />
        {shouldShowProductListLoader && (
          <ComponentLoader
            size="small"
            contentClassName={styles['component-loader--comparison-cards']}
          />
        )}
      </div>
      <ProductListKey hasCatalogEntries={hasCatalogEntries} />
      <LongDescription longDescriptionContent={longDescriptionContent} />
    </div>
  );
};

ProductListMainContent.propTypes = {
  handleEquipmentCheck: PropTypes.func,
  pageDoesntExist: PropTypes.bool,
  espotData: PropTypes.arrayOf(PropTypes.string)
};

export default ProductListMainContent;
